import { useRouter } from '@tanstack/react-router';
import { ConnectorRouteView, JourneysConnectorHandoff, useConnectorHandoffHrefs } from '@/features/integrations';
import { ProtectedRoute } from '@/services/router/components/protected-route';
import { generatePath } from '@/services/router/generate-path';
import { RumPageRendered } from '@/services/rum/use-page-rendered';
import CustomerioConnectorPage from './index.page';

/** The two spellings of this connector's URL. */
function useHandoffHrefs() {
  const router = useRouter();
  return useConnectorHandoffHrefs({
    buildMigrated: (workspaceId) =>
      router.buildLocation({ to: '/workspaces/$workspaceId/integrations/customerio', params: { workspaceId } }).href,
    buildLegacy: (workspaceId) =>
      router.buildLocation({ to: '/workspaces/$workspaceId/journeys/integrations/customerio', params: { workspaceId } })
        .href,
  });
}

/**
 * The old `/journeys/integrations/customerio` URL — what the integrations directory and the
 * activity-log deep link point at.
 */
export function JourneysCustomerioHandoff() {
  const { migrated } = useHandoffHrefs();

  return <JourneysConnectorHandoff isMigrated migratedHref={migrated} />;
}

/**
 * The migrated `/integrations/customerio` URL.
 *
 * `ConnectorRouteView` applies the gates Ember's `integrations` root route applied. This page's own
 * `beforeModel` added `account/api_credentials/view` on top, so that gate nests inside — and the
 * order matters: a user missing both lands where Ember's parent redirect sent them.
 */
export function CustomerioConnectorRouteView() {
  const { legacy } = useHandoffHrefs();

  return (
    <ConnectorRouteView isMigrated legacyHref={legacy}>
      {(workspaceId) => (
        // Ember's own redirect resolved to this page's parent route, the integrations index.
        <ProtectedRoute
          permission="account/api_credentials/view"
          redirectTo={generatePath('/workspaces/:workspaceId/integrations', { workspaceId })}
        >
          <RumPageRendered>
            <CustomerioConnectorPage />
          </RumPageRendered>
        </ProtectedRoute>
      )}
    </ConnectorRouteView>
  );
}
